import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import MenuItem from './menuItem'
import MenuTree from './menuTree'
import { withRouter } from 'react-router-dom';

import { carregarUsuario } from '../../auth/authActions';

class Menu extends Component {

	state = {
		acessoAberto: null,
		cadastroAberto: null
	}

	constructor(props) {
		super(props);

		let idInterval = setInterval(() => {
			if (this.props.usuario) {
				this.props.carregarUsuario();
				clearInterval(idInterval);
			}
		}, 2000);
	}

	render() {

		const usuarioCarregado = this.props.usuarioCarregado;

		let selecionado = '';
		if (this.props.location && this.props.location.pathname) {
			selecionado = this.props.location.pathname;
		}

		if (selecionado != '/' 
			&& this.state.acessoAberto == null
			&& this.state.cadastroAberto == null
		) {
			if (selecionado == '/usuario') {
				this.setState({
					...this.state,
					acessoAberto: true
				});
			} else if (selecionado == '/empresa' || selecionado == '/fornecedor' || selecionado == '/exame'
				|| selecionado == '/grupoFaturamento' || selecionado == '/destinatario') {
				this.setState({
					...this.state,
					cadastroAberto: true
				});
			}
		}		
		
		return (
			<nav className="mt-2">

				{usuarioCarregado &&			    
				<ul className="nav nav-pills nav-sidebar flex-column nav-flat nav-compact" data-widget="treeview" role="menu" data-accordion="false">
					<MenuItem path='/' label='Dashboard' icon='fas fa-tachometer-alt' active={selecionado == '/'} />
					
					{usuarioCarregado.acesso_cadastro_usuario &&
					<MenuTree icon={'fas fa-user-lock'} label={'Acesso'}
						display={this.state.acessoAberto}
						onClick={() =>
							this.setState({
								...this.state,
								acessoAberto: !this.state.acessoAberto,
							})
						} >
						<MenuItem submenu path='usuario' label='Usuário' icon='fas fa-id-card-alt' active={selecionado == '/usuario'} />
					</MenuTree>}

					{usuarioCarregado.acesso_cadastros &&
					<MenuTree icon={'fas fa-cogs'} label={'Cadastro'}
						display={this.state.cadastroAberto}
						onClick={() =>
							this.setState({
								...this.state,
								cadastroAberto: !this.state.cadastroAberto,
							})
						} >
						<MenuItem submenu path='empresa' label='Empresa' icon='fas fa-building' active={selecionado == '/empresa'} />
						<MenuItem submenu path='fornecedor' label='Fornecedor' icon='fas fa-users' active={selecionado == '/fornecedor'} />
						<MenuItem submenu path='centroCusto' label='Centro de Custo' icon='fas fa-list' active={selecionado == '/centroCusto'} />
						<MenuItem submenu path='destinatario' label='Origem/Destino' icon='fas fa-piggy-bank' active={selecionado == '/destinatario'} />
						<MenuItem submenu path='formaPagamento' label='Forma de Pagamento' icon='fas fa-credit-card' active={selecionado == '/formaPagamento'} />
						<MenuItem submenu path='grupo' label='Grupo' icon='fas fa-list-alt' active={selecionado == '/grupo'} />
						<MenuItem submenu path='analitica' label='Analítica' icon='fas fa-search-dollar' active={selecionado == '/analitica'} />
					</MenuTree>}

					{usuarioCarregado.acesso_despesas &&
					<MenuItem path='despesa' label='Despesa' icon='fas fa-file-invoice-dollar' active={selecionado == '/despesa'} />}

					{usuarioCarregado.acesso_receitas &&
					<MenuItem path='receita' label='Receita' icon='fas fa-money-check-alt' active={selecionado == '/receita'} />}
					
					{(usuarioCarregado.acesso_receitas && usuarioCarregado.acesso_despesas) &&
					<MenuItem path='dre' label='DRE' icon='fas fa-funnel-dollar' active={selecionado == '/dre'} />}
				</ul>}
			</nav>
		);
	}
}

const mapStateToProps = state => ({
	usuario: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado
});
const mapDispatchToProps = dispatch => bindActionCreators({ carregarUsuario }, dispatch);
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Menu));
